import { Button, Col, Form, Modal, Row, Space, Typography } from "antd"
import { FunctionComponent, useEffect } from "react"
import { InputForm } from "../form/InputForm"

interface IProps {
    open: boolean
    추천코드?: string
    onPress: (추천코드: string) => void
    onClosed: () => void
}

export const 추천코드정보입력Modal: FunctionComponent<IProps> = (props) => {
    const {
        open,
        추천코드,
        onPress,
        onClosed,
    } = props

    const [form] = Form.useForm()

    const Footer = () => {
        return (
            <Row>
                <Col span={24} style={{ textAlign: 'end' }}>
                    <Space>
                        <Button
                            type="default"
                            onClick={onClosed}
                        >
                            취소
                        </Button>
                        <Button
                            className="primary small"
                            onClick={() => {
                                form.validateFields()
                                    .then((values) => {
                                        onPress(values.code)
                                    })
                                    .catch((e) => {
                                        alert('필수 정보를 입력해주세요')
                                        return
                                    })
                            }}
                        >
                            등록
                        </Button>
                    </Space>
                </Col>
            </Row>
        )
    }

    useEffect(() => {
        if (추천코드) {
            form.setFieldValue('code', 추천코드)
        } else {
            form.resetFields()
        }
    }, [추천코드])

    return (
        <Modal
            open={open}
            destroyOnClose={true}
            title={'추천코드 정보'}
            onCancel={() => { onClosed() }}
            footer={<Footer />}
        >
            <Form form={form}>
                <Row gutter={[12, 6]} style={{ marginTop: 40, }}>
                    <Col span={24}>
                        <Row gutter={[0, 10]}>
                            <Col span={24}>
                                <Typography.Text
                                    style={{
                                        fontSize: 14,
                                    }}
                                >
                                    {`[선택] 추천코드`}
                                </Typography.Text>
                            </Col>
                            <InputForm
                                name='code'
                                placeholder='추천코드를 입력하세요'
                                rules={[{ required: true, message: "추천코드를 입력하세요" }]}
                                style={{
                                    borderRadius: 8,
                                    fontSize: 16,
                                }}
                                layout={{ lg: { span: 24 }, sm: { span: 24 }, xs: { span: 24 } }}
                            />
                        </Row>
                    </Col>
                </Row>
            </Form>
        </Modal>
    )
}